import { I18NEXT } from '@/i18n.ts'
import { LegacyRouter } from '@/router'
import { axiosClient } from '@/utils/axios-client'
import { defineStore } from 'pinia'
import { type Ref, ref } from 'vue'

import type { AppInitResponse } from '@/legacy/legacy-main'
import type { OrganizationStroomFieldConfig } from '@/types/organization-config'
import { getStroomConfig } from '@/utils/organization-config'

export const useLegacyAppStore = defineStore('legacyAppStore', () => {
  const showErrorModal: Ref<boolean> = ref(false)

  const appInitData: Ref<AppInitResponse | null> = ref(null)
  const subModuleIds: Ref<number[]> = ref([])
  const journeyTemplateFieldConfigs: Ref<OrganizationStroomFieldConfig[]> = ref<
    OrganizationStroomFieldConfig[]
  >([])

  async function fetchAppInitData() {
    try {
      const response = await axiosClient.request<AppInitResponse>({
        url: '/auth/api/init',
        method: 'GET',
      })

      sessionStorage.setItem('initData', JSON.stringify(response.data))

      window.i18Editor = new I18NEXT(response.data)
      window.i18Editor.initTranslations(response.data)
      window.router = new LegacyRouter()
      appInitData.value = response.data

      if (appInitData.value == null) {
        return
      }

      if (appInitData.value.orgConfig && Object.keys(appInitData.value.orgConfig).length > 0) {
        subModuleIds.value = [
          ...appInitData.value.orgConfig.modules.flatMap(module =>
            module.subModules.map(subModule => subModule.id)
          ),
        ]

        const appOrgParameters = appInitData.value.orgConfig.parameters

        if (appOrgParameters != null) {
          const stroomConfig = getStroomConfig(appOrgParameters)

          if (stroomConfig) {
            journeyTemplateFieldConfigs.value = stroomConfig.parameters
          }
        }
      }

      for (const module of appInitData.value.user.modules) {
        if (subModuleIds.value.includes(module)) continue

        subModuleIds.value.push(module)
      }

      return response.data
    } catch (error) {
      window.sessionStorage.clear()
      window.localStorage.clear()
      throw error
    }
  }

  return {
    showErrorModal,
    appInitData,
    subModuleIds,
    journeyTemplateFieldConfigs,
    fetchAppInitData,
  }
})
